// Instances are one per tenant and named after their host, so the first hostname
// label is the display name unless the environment overrides it.
const resolveInstanceName = () => {
  const configured = import.meta.env.VITE_INSTANCE_NAME;
  if (configured) {
    return configured;
  }

  const [subdomain] = window.location.hostname.split(".");
  return subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
};

const CONFIG = {
  INSTANCE_NAME: resolveInstanceName(),
  IS_PHONE_ENABLED: import.meta.env.VITE_IS_PHONE_ENABLED === "True",
  LOGO_SRC: import.meta.env.VITE_LOGO_SRC,
  HEADER_LOGO_SRC: import.meta.env.VITE_HEADER_LOGO_SRC,
  HEADER_LOGO_W: import.meta.env.VITE_HEADER_LOGO_W,
  HEADER_LOGO_H: import.meta.env.VITE_HEADER_LOGO_H,
  CC_EMAIL: import.meta.env.VITE_CC_EMAIL,
  CONSTANT_CONTACT_ENABLED:
    import.meta.env.VITE_CONSTANT_CONTACT_ENABLED === "True",
  UNLAYER_PROJECT_ID: import.meta.env.VITE_UNLAYER_PROJECT_ID,
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  ENABLE_PIRACY: import.meta.env.VITE_ENABLE_PIRACY === "True",
  MAINTENANCE_MODE: import.meta.env.VITE_MAINTENANCE_MODE === "true",
};

export const MAINTENANCE_MODE = CONFIG.MAINTENANCE_MODE;
export default CONFIG;
